// import './App.css';
// import './App-JBF.css';
import './App-JB.css';
// import './App-F.css';
import AppConfig from './components/AppConfig';
// import AppConfig from './components/CreateLevaFromJsonEdit2';

function App() {
  return (
    <AppConfig/>
  );
}

export default App;
